import {LAYERDIV} from './LayerDivTypes'

export const changeLayerDiv = layerDiv => {
    return {
        type: LAYERDIV,
        load: layerDiv
    }
}
export const selectNewLayerDiv = (layerDiv) => {

    return (dispatch) => {
        dispatch(changeLayerDiv(layerDiv))
    }

}